"use client";

export { default } from "../../src/app/components/error";
